import React, { MouseEventHandler, useState } from 'react';
import styles from './NotifyForm.module.scss';
import { Button, Title, Group, TextInput, LoadingOverlay, Text, Alert, Checkbox } from '@mantine/core';
import { store } from '../../redux/store';
import { useForm } from '@mantine/form';
import { appActions, selectNotifyState, selectCurrentEmail,selectValidTill, selectDomainCountry, selectSecondUserEmail, selectSecondUserCount } from '../../redux/appSlice';
import { useDispatch, useSelector } from 'react-redux';
import { setEmail } from '../../services/api'
import { LinkComponet, InfoCircle } from '../icons/Icons';

import useStyles from '../../hooks/useStyles';
import useTranslation from '../../hooks/useTranslation';

const LS_EMAIL = "rememberEmail"

type Props = {
  executeRecaptcha: any,
  children?: React.ReactNode,
  onCancel?: MouseEventHandler,
  onSuccess?: Function,
  sendLabel?:string
}

function NotifyForm({ executeRecaptcha, onCancel, onSuccess, sendLabel, children }: Props) {
  const dispatch = useDispatch()
  const notifyState = useSelector(selectNotifyState)
  const currentEmail = useSelector(selectCurrentEmail)
  const secondUserEmail = useSelector(selectSecondUserEmail)
  const secondUserCount = useSelector(selectSecondUserCount)
  const validTillValue = useSelector(selectValidTill)
  const domainCountry = useSelector(selectDomainCountry)

  const [sendingState, setSendingState] = useState('not-ready')

  const validTill = new Date(validTillValue)
  const validDate = validTill.getDate() + '.' + (validTill.getMonth()+1) + '.' + validTill.getFullYear()

  const { classes } = useStyles()
  const t = useTranslation()

  const form = useForm({
    initialValues: {
      email: localStorage.getItem(LS_EMAIL) || (currentEmail !== '' ?currentEmail :(secondUserEmail ?secondUserEmail :'')),
      remember: !!localStorage.getItem(LS_EMAIL),
    },
    validate: {
      email: (value) => (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value) ? null : t('ui-form-invalid-email')),
    },
  });

  const saveEmail = async (email:string) => {
    setSendingState('sending')
    const { recaptchaToken, recaptchaNumber } = await executeRecaptcha('download_kone_com')
    const comingFromSharedPage =  (window.sessionStorage.getItem("currentEmail") === null)
    if(!comingFromSharedPage) {
      dispatch(appActions.setCurrentEmail(email))
    } else {
      dispatch(appActions.setSecondUserEmail(email))
    }
    setEmail(store, {eMail: email, comingFromSharedPage, secondUserCount, recaptchaToken, recaptchaNumber}).then( result => {
      if(result.status !== 'Error') {
        if(comingFromSharedPage) {
          dispatch( appActions.setSecondUserCount(result.emailIndex))
        }        
        setSendingState('ready')
        if(onSuccess) {
          onSuccess()
        }
      } else {
        setSendingState('error')
      }
    })

  }

  return (
    <>
      <LoadingOverlay visible={sendingState === 'sending'} />
      <form onSubmit={form.onSubmit((values) => {
        // TODO: Do real implementation
        saveEmail(values.email)
      })}>
        <Group direction="column" align="stretch" className={styles.NotifyForm}>
          <Title order={3}>{t('ui-modal-email-notify-header')}</Title>
          { sendingState === 'error' &&
                <Alert icon={<InfoCircle />} color="blue" mb={16}>
                  {t('ui-alert-failed-to-send-form-general')}
                </Alert>
          }
          <TextInput
            required
            label={t('ui-form-email')}
            placeholder={t('cad-notify-form-email-placeholder')}
            {...form.getInputProps('email')}
            className={classes.inputFieldLabel}
          />
          <Checkbox
            classNames={{ label: styles.label }}
            label={"Remember me"}
            checked={form.values.remember}
            {...form.getInputProps('remember')}
          />

          <div className={styles.shareDesign}>
            <div className={styles.shareDesignIcon}>
              <LinkComponet size={40} />
            </div>
            <div className={styles.shareDesignBody}>
              <Title order={4} className={styles.uppercase}>{t('ui-main-page-share-design')}</Title>
              <Text className={styles.shareLink}><a href={ window.location.href }>{ window.location.href }</a></Text>
              <Text className={styles.shareInfo}>{t('ui-main-page-share-link-notice')}</Text>
              <Text className={styles.shareInfo}>{t('ui-main-page-valid-label')} {validDate}</Text>
            </div>
          </div>

          <Text size="sm">
            {t('ui-contact-privacy-statement-1')}
              <a
                tabIndex={-1}
                className="readMore"
                href={domainCountry?.privacyStatement}
                target="_blank"
                rel="noopener noreferrer"
              >
                &nbsp;
                {t('ui-contact-privacy-statement-2')}
              </a>
            {t('ui-contact-privacy-statement-3')}
          </Text>

          <Group position="right" spacing="sm" mb={1} >
            <Button onClick={onCancel} variant="outline" className={classes.formButton}>{t("ui-general-back")}</Button>
            <Button type="submit" className={classes.formButton}>{sendLabel ?t(sendLabel) :t("ui-general-send")}</Button>
          </Group>
        </Group>
        <LoadingOverlay visible={notifyState === "waiting"} />
      </form>
    </>

  );
}

export default NotifyForm;